<template>
	<m-main-layout v-if="formData">
		<div class="page-content-main">
			<el-form :model="formData" ref="form" label-width="auto" class="margin-top">
				<el-form-item label="公司名称">
					{{formData.company}}
				</el-form-item>
				<el-form-item label="评估认证" prop="tags">
					<el-tag
						:key="tag"
						v-for="tag in formData.pgrz"
						closable
						:disable-transitions="false"
						@close="handleClose(tag)" class="margin-right">
						{{tag}}
					</el-tag>
					<el-input
						class="input-new-tag"
						v-if="inputVisible"
						v-model="inputValue"
						ref="saveTagInput"
						size="small"
						@keyup.enter.native="handleInputConfirm"
						@blur="handleInputConfirm"
						style="width: 100px;"
					>
					</el-input>
					<el-button v-else class="button-new-tag" size="small" @click="showInput">+ 添加评估认证</el-button>
				</el-form-item>
				<el-form-item prop="is_tuijian" label="是否推荐">
					<el-switch
						v-model="formData.is_tuijian"
						active-color="#13ce66"
						:active-value="1"
						:inactive-value="0"
						active-text="是"
						inactive-text="否">
					</el-switch>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="submitForm('form')">确定</el-button>
					<el-button type="" @click="$router.back()">返回</el-button>
				</el-form-item>
			</el-form>
		</div>
	</m-main-layout>
</template>

<script>
export default {
	name: "edit",
	data() {
		return {
			inputVisible: false,
			inputValue: '',
			formData: {
				id:'',
				pgrz:[],
				is_tuijian:0,
				company:'',
				uid:''
			},
		}
	},
	created() {
		this.formData.id  = this.$route.query.id ? this.$route.query.id :'';
	},
	mounted() {
		if(this.formData.id) {
			this.getDetail();
		}
	},
	methods: {
		getDetail(){
			let _this = this;
			_this.$http.httpPost({
				url: '/UserCompany/detail',
				datas: {id:this.formData.id},
				success: (res) => {
					_this.formData.pgrz = res.pgrz ? res.pgrz : [];
					_this.formData.is_tuijian = res.is_tuijian;
					_this.formData.company = res.user.company;
					_this.formData.uid = res.user.uid;
				}
			});
		},
		
		handleClose(tag) {
			this.formData.pgrz.splice(this.formData.pgrz.indexOf(tag), 1);
		},
		
		showInput() {
			this.inputVisible = true;
			this.$nextTick(_ => {
				this.$refs.saveTagInput.$refs.input.focus();
			});
		},
		
		handleInputConfirm() {
			let inputValue = this.inputValue;
			if (inputValue) {
				this.formData.pgrz.push(inputValue);
			}
			this.inputVisible = false;
			this.inputValue = '';
		},
		submitForm(formName) {
			let _this = this;
			
			this.$refs[formName].validate((valid,obj) => {
				if (valid) {
					_this.$http.httpPost({
						url: '/UserCompany/edit',
						datas: _this.formData,
						success: (res) => {
							_this.$router.back();
						}
					});
				}
			});
		},
	}
}
</script>
